import React from 'react';
import { AlertCircle, Check } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  DialogTitle,
  DialogClose
} from '../../../../components/ui/Dialog';
import Button from '../../../../components/ui/Button';

interface VisibilityAcknowledgmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAcknowledge: () => void;
  t: (key: string) => string;
}

const VisibilityAcknowledgmentModal: React.FC<VisibilityAcknowledgmentModalProps> = ({
  isOpen,
  onClose,
  onAcknowledge,
  t
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent size="sm">
        <DialogHeader className="flex items-center gap-3">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
            <AlertCircle className="w-6 h-6 text-primary" />
          </div>
          <DialogTitle>{t('Public Profile Acknowledgment')}</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <p className="text-muted-foreground mb-4">
            {t('By making your profile public, you acknowledge that:', { nsSeparator: false })}
          </p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex items-start gap-2">
              <Check className="w-4 h-4 text-success mt-0.5 flex-shrink-0" />
              <span>{t('Your profile will be accessible to anyone with the link, including people outside your organization')}</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="w-4 h-4 text-success mt-0.5 flex-shrink-0" />
              <span>{t('Only the information you choose to share will be visible')}</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="w-4 h-4 text-success mt-0.5 flex-shrink-0" />
              <span>{t('You can disable public access at any time')}</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="w-4 h-4 text-success mt-0.5 flex-shrink-0" />
              <span>{t('Your profile complies with company policies and guidelines')}</span>
            </li>
          </ul>
        </DialogBody>

        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" className="flex-1">{t('Cancel')}</Button>
          </DialogClose>
          <Button onClick={onAcknowledge} className="flex-1">
            {t('I Understand')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default VisibilityAcknowledgmentModal;
